/**
 * The colour keys elmagico CMS returns from `/api/cms/getById`. The mobile SDK,
 * the gamification widget and this portal all read the same thirteen names, so
 * this list is the shared contract: adding a name here without adding it in the
 * CMS gives every tenant an empty value. `applyThemeColors` writes each one to
 * the CSS variable `--color-<key>`, which `tailwind.config.ts` reads back.
 */
export const MAGICO_COLOR_KEYS = [
  "activeColor",
  "mainColor",
  "secondTextColor",
  "mainTextColor",
  "variantTextColor",
  "buttonColor",
  "errorColor",
  "successColor",
  "failingImageColor",
  "failingImageBg",
  "pendingRewardText",
  "pendingRewardButton",
  "rewardDialogColor",
] as const;

export type MagicoColorKey = (typeof MAGICO_COLOR_KEYS)[number];

/**
 * Hex strings such as `#2c4baf`, keyed by the names above. This type is a filter
 * on the response, not a promise about it: the CMS may send other keys, and
 * `applyThemeColors` drops them because it walks MAGICO_COLOR_KEYS rather than
 * the response.
 */
export type MagicoColors = Partial<Record<MagicoColorKey, string>>;

export interface IMagicoAppData {
  id: number;
  name: string;
  description: string;
  logo: string;
  static_pages: Record<string, any>;
  images: Record<string, string>;
  colors: MagicoColors;
  configs: Record<string, string>;
}

export interface IAppConfigState {
  logo: string;
  static_pages: Record<string, any>;
  images: Record<string, string>;
  colors: MagicoColors;
  configs: Record<string, string>;
}

export interface AppConfigApiResponse {
  success: boolean;
  data: IMagicoAppData;
  message?: string;
}